module.exports = __webpack_public_path__ + "img/enterprise-features-arrow.88c539bb.svg";